import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo
} from 'react';
import PropTypes from 'prop-types';

export const SiteSettingsContext = createContext();

export const useSiteSettings = () => useContext(SiteSettingsContext);

export function SiteSettingsProvider({ children }) {
  const [currentSiteSettings, setCurrentSiteSettings] = useState({});
  const [allSiteSettings, setAllSiteSettings] = useState([]);

  const currentDomain = window.location.hostname;

  useEffect(() => {
    const fetchCurrentSiteSettings = async () => {
      const response = await fetch(`/api/site/settings/?host=${currentDomain}`);
      const data = await response.json();
      if (data) {
        setCurrentSiteSettings(data);
      }
    };

    const fetchAllSiteSettings = async () => {
      const response = await fetch(`/api/site/settings/`);
      const data = await response.json();
      if (data) {
        setAllSiteSettings(data);
      }
    };

    fetchCurrentSiteSettings();
    fetchAllSiteSettings();
  }, []);

  const siteSettingsValue = useMemo(
    () => ({
      currentSiteSettings,
      allSiteSettings,
      setCurrentSiteSettings,
      setAllSiteSettings
    }),
    [currentSiteSettings, allSiteSettings]
  );

  return (
    <SiteSettingsContext.Provider value={siteSettingsValue}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

SiteSettingsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default SiteSettingsContext;
